var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"end",style:({backgroundColor: _vm.navBj})},[_c('a',{on:{"click":_vm.privacyClick}},[_vm._v("Privacy")]),_c('a',{on:{"click":_vm.contactClick}},[_vm._v("Contact us")])])
}
var staticRenderFns = []

export { render, staticRenderFns }